var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { Box } from '@creditas-ui/layout';
import { styled } from '@creditas-ui/system';
import { getTypography, ifProp, selectTheme } from '@creditas-ui/utilities';
var InputLabel = styled(Box.withComponent('label', process.env.NODE_ENV === "production" ? {
  target: "elyrh930"
} : {
  target: "elyrh930",
  label: "InputLabel"
}))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  cursor: ", ";\n  margin-left: ", ";\n  ", ";\n"])), ifProp('disabled', selectTheme('checkbox.label.disabled.color'), ifProp('active', selectTheme('checkbox.label.active.color'), selectTheme('checkbox.label.color'))), ifProp('disabled', 'not-allowed', 'pointer'), selectTheme('checkbox.label.marginLeft'), getTypography('bodyMdRegular'));
export { InputLabel };
//# sourceMappingURL=InputLabel.js.map